import React, { ReactElement, useMemo, useState } from "react";

import { PnrDataContext } from "@cart-client/contexts/PnrDataContext";

export function PnrDataContextProvider({ children }: { children: React.ReactNode }): ReactElement {
    const [isEnterPnr, setIsEnterPnr] = useState(false);
    const [isIrctcPnrHalfCardOpen, setIsIrctcPnrHalfCardOpen] = useState(false);

    const value = useMemo(
        () => ({
            isEnterPnr,
            setIsEnterPnr,
            isIrctcPnrHalfCardOpen,
            setIsIrctcPnrHalfCardOpen,
        }),
        [isEnterPnr, isIrctcPnrHalfCardOpen],
    );

    return <PnrDataContext.Provider value={value}>{children}</PnrDataContext.Provider>;
}
